import useTranslator from "../../hooks/useTranslator";
import { useContext, useEffect, useState } from "react";
import { haveValue, toast } from "../../helper/common";
import LandLordContext from "../../context/landlord/LandLordContext";
import AuthContext from "../../context/auth/AuthContext";
import { RowButton, Button, Modal, Select, TextField } from "../design";
import FullAddressFormModal from "./FullAddressFormModal";
import "./addPropertyModal.css";

const AddPropertyManuallyModal = (props) => {
  const {
    step,
    setStep,
    handleShow,
    formData,
    setFormData,
    handleInputChange,
    defaultState,
    handleSubmit,
    handleBackCurrent = null,
    isLandlord = false,
    setIsAddManuallyModal,
    submitLoading,
  } = props;

  const { _t } = useTranslator();
  const landLordContext = useContext(LandLordContext);
  const authContext = useContext(AuthContext);
  const { setLoading } = authContext;
  const { validateCadastre, getBuildingData, properties, getAutoCompleteList } =
    landLordContext;

  const [floorVals, setFloorVals] = useState([]);
  const [fromRef, setFromRef] = useState(false);
  const [autoCompleteList, setAutoCompleteList] = useState([]);
  const [isSelected, setIsSelected] = useState(false);
  const [changeEntered, setChangeEntered] = useState(false);
  const [enteredAddress, setEnteredAddress] = useState("");
  const [doorVals, setDoorVals] = useState([]);
  const [allCadastre, setAllCadastre] = useState([]);
  const [validateLoading, setValidateLoading] = useState(false);
  const [stepOneErrors, setStepOneErrors] = useState({});

  const getRequiredMessage = (labelKey) => {
    const translatedRequiredSuffix = _t("isRequired");
    const requiredSuffix =
      translatedRequiredSuffix === "isRequired"
        ? "is required"
        : translatedRequiredSuffix;
    return `${_t(labelKey)} ${requiredSuffix}`;
  };

  useEffect(() => {
    if (!changeEntered) {
      const timeoutId = setTimeout(async () => {
        getAutoCompleteList(enteredAddress)
          .then((res) => {
            if (
              haveValue(res?.from_ref) &&
              res?.from_ref == true &&
              res?.results.length > 0
            ) {
              setFromRef(true);
              const val = res?.results[0];
              const temp_data = { ...formData };
              // const temp = {
              temp_data.street_type = val?.tipo_via;
              temp_data.street = val?.via;
              temp_data.street_number = val?.numero_via;
              temp_data.postcode = val?.cp;
              temp_data.staircase = val?.escalera;
              temp_data.floor = val?.piso;
              temp_data.door = val?.puerta;
              temp_data.municipality = val?.municipio;
              temp_data.province = val?.provincia;
              temp_data.code_ine = val?.cod_ine;
              temp_data.code_via = val?.cod_via;
              temp_data.cadastral_reference = val?.referencia_catastral;
              temp_data.area = val?.sup_util;
              // };
              setFormData(temp_data);
              setIsSelected(true);
            } else {
              setFromRef(false);
              if (haveValue(enteredAddress) && res.length == 0) {
                const not_listed = [{ address: "not_found_property" }];
                setAutoCompleteList(not_listed);
              } else {
                setAutoCompleteList(res);
              }
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }, 500);

      return () => clearTimeout(timeoutId);
    }
  }, [enteredAddress]);

  const handleValidateCadastre = async (e) => {
    e.preventDefault();
    setStepOneErrors({});

    if (haveValue(formData?.code_ine) && !haveValue(formData?.street_number)) {
      setStepOneErrors({ street_number: true });
      return;
    }

    if (fromRef == true) {
      handleShow();
    } else {
      if (
        haveValue(formData?.code_ine) &&
        haveValue(formData?.code_via) &&
        haveValue(formData?.street_number)
      ) {
        setValidateLoading(true);
        validateCadastre(
          formData.code_ine,
          formData?.code_via,
          formData?.street_number
        )
          .then((res) => {
            const temp_data = { ...formData };
            temp_data.street_type = res[0].tipo_via;
            temp_data.street = res[0].via;
            temp_data.postcode = res[0].cp;
            temp_data.municipality = res[0].municipio;
            temp_data.province = res[0].provincia;
            if (haveValue(res[0].referencia_catastral)) {
              temp_data.cadastral_reference = res[0].referencia_catastral;
              setFormData(temp_data);
              fetchBuildingData(res[0].referencia_catastral);
            } else {
              setFormData(temp_data);
              handleRedirectManual();
            }
            setValidateLoading(false);
          })
          .catch((err) => {
            console.log(err);
            setValidateLoading(false);
          })
          .finally(() => {
            setValidateLoading(false);
          });
      }
    }
  };

  const fetchBuildingData = async (cadastral_reference) => {
    getBuildingData(
      cadastral_reference,
      formData.code_via,
      formData.street_number
    )
      .then((res) => {
        if (res.length == 1 && !haveValue(res[0].vertical)) {
          setFormData((prev) => ({ ...prev, area: res[0].sup_util }));
          setStep(3);
        } else if (res.length == 0) {
          setStep(3);
        } else {
          const highestFloor = [
            ...new Set(res.map((item) => item.piso)),
          ].sort();
          const highestLetter = {};
          res.forEach((item) => {
            const piso = item.piso;
            const puerta = item.puerta;

            if (!(piso in highestLetter)) {
              highestLetter[piso] = [];
            }
            highestLetter[piso][`${puerta}`] = item;
          });

          setAllCadastre(res);

          setFloorVals(highestFloor);
          setDoorVals(highestLetter);

          handleNext();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const addVals = () => {
    setLoading(true);
    const check = properties.filter(
      (prop) =>
        prop?.street == `${formData?.street_type}, ${formData?.street}` &&
        prop?.street_number == formData?.street_number &&
        prop?.floor_number == formData?.floor &&
        prop?.flat_number == formData?.door
    );

    if (check.length > 0) {
      toast.error(_t("propertyAlreadyExists"));
    } else {
      const current_selected = doorVals[formData.floor][formData.door];
      const temp_cadastre = allCadastre.filter(
        (item) => item.piso == formData.floor && item.puerta == formData.door
      );

      setFormData((prev) => ({
        ...prev,
        area: current_selected.sup_util,
        staircase: current_selected.escalera,
        cadastral_reference: temp_cadastre[0]?.referencia_catastral,
      }));
      handleShow();
    }
    setLoading(false);
  };

  const handleFloorInput = async (e) => {
    e.preventDefault();
    setFormData((prev) => ({
      ...prev,
      area: doorVals[formData?.floor][formData?.door].sup_util,
    }));
  };

  const handleSelectAddr = async (e) => {
    setEnteredAddress(e.target.textContent);
    const code_ine = e.target.getAttribute("data-cod-ine");
    const code_via = e.target.getAttribute("data-cod-via");
    const entered_address = e.target.getAttribute("data-entered-address");
    setEnteredAddress(entered_address);
    setChangeEntered(true);
    const street_number = haveValue(e.target.getAttribute("data-numero-via"))
      ? e.target.getAttribute("data-numero-via")
      : "";
    setFormData((prevData) => ({
      ...prevData,
      ...defaultState,
      code_ine,
      code_via,
      street_number,
    }));
    setIsSelected(true);
  };

  const handleAddressType = (e) => {
    setChangeEntered(false);
    setEnteredAddress(e.target.value);
    setFormData((prevData) => ({ ...prevData, code_ine: "", code_via: "" }));
  };

  const handleNext = () => {
    setStep((prevStep) => prevStep + 1);
  };

  const handleGoBack = () => {
    setStep((prevStep) => prevStep - 1);
  };

  const handleRedirectManual = () => {
    setStep(3);
  };

  const closeModal = () => setIsAddManuallyModal(false);

  // Step 3 is the full address form; it brings its own popup.
  if (step === 3) {
    return (
      <FullAddressFormModal
        isLandlord={isLandlord}
        setIsAddManuallyModal={setIsAddManuallyModal}
        formData={formData}
        handleInputChange={handleInputChange}
        handleSubmit={handleSubmit}
        setStep={setStep}
        setFormData={setFormData}
        submitLoading={submitLoading}
      />
    );
  }

  // Step 5 never had content.
  if (step !== 1 && step !== 2 && step !== 4) return null;

  const formId = `add-property-step-${step}`;

  return (
    <Modal
      open
      onClose={closeModal}
      size="md"
      align="start"
      actionsLayout="end"
      title={
        step === 4
          ? `${_t("municipalityAndProvince")}?`
          : _t("whatIsYourAddress")
      }
      actions={
        <>
          {step === 1 && haveValue(handleBackCurrent) && (
            <Button variant="secondary" size="lg" onClick={handleBackCurrent}>
              {_t("goBack")}
            </Button>
          )}
          {step !== 1 && (
            <Button variant="secondary" size="lg" onClick={handleGoBack}>
              {_t("goBack")}
            </Button>
          )}
          {step === 1 && (
            <Button
              size="lg"
              type="submit"
              form={formId}
              disabled={!haveValue(formData?.code_ine)}
              loading={validateLoading}
            >
              {_t("next")}
            </Button>
          )}
          {step === 2 && (
            <Button
              size="lg"
              type="submit"
              form={formId}
              onClick={addVals}
              disabled={
                !haveValue(formData?.floor) || !haveValue(formData?.door)
              }
            >
              {_t("findProperty")}
            </Button>
          )}
          {step === 4 && (
            <Button size="lg" type="submit" form={formId}>
              {_t("submit")}
            </Button>
          )}
        </>
      }
    >
      {step === 1 && (
        <form
          id={formId}
          className="property-form"
          onSubmit={handleValidateCadastre}
        >
          <div className="property-form__row">
            <TextField
              id="add-property-address"
              name="entedAddress"
              label={_t("streetOrReference")}
              value={enteredAddress}
              onChange={handleAddressType}
              onKeyDown={(e) => setIsSelected(false)}
              placeholder={_t("enterStreetOrReference")}
              autoComplete="off"
            />
            <TextField
              id="add-property-number"
              name="street_number"
              label={_t("number")}
              value={formData.street_number}
              onChange={(e) => {
                if (stepOneErrors.street_number) {
                  setStepOneErrors((prev) => ({
                    ...prev,
                    street_number: false,
                  }));
                }
                handleInputChange(e);
              }}
              disabled={!haveValue(formData?.code_ine)}
              placeholder={_t("enterNumber")}
              onKeyDown={(e) => {
                const allowedKeys = [
                  "Backspace",
                  "Tab",
                  "ArrowLeft",
                  "ArrowRight",
                  "Delete",
                ];
                if (!/[0-9]/.test(e.key) && !allowedKeys.includes(e.key)) {
                  e.preventDefault();
                }
              }}
              error={
                stepOneErrors.street_number && getRequiredMessage("number")
              }
            />
          </div>
          {haveValue(autoCompleteList) &&
            autoCompleteList.length > 0 &&
            haveValue(enteredAddress) &&
            isSelected == false && (
              <ul className="property-suggestions">
                {autoCompleteList.map((ele, index) =>
                  ele.address == "not_found_property" ? null : (
                    <li key={index}>
                      {/* the data-* values are read from the clicked button */}
                      <RowButton
                        type="button"
                        className="property-suggestions__item"
                        data-entered-address={`${ele?.tipo_via} ${ele?.via}, ${ele?.address_2}`}
                        data-numero-via={
                          haveValue(ele?.numero_via) ? ele?.numero_via : null
                        }
                        data-cod-ine={ele.cod_ine}
                        data-cod-via={ele.cod_via}
                        onClick={handleSelectAddr}
                      >
                        {ele.address}
                      </RowButton>
                    </li>
                  )
                )}
                <li key={"not_listed_house"}>
                  <RowButton
                    type="button"
                    className="property-suggestions__item property-suggestions__item--muted"
                    onClick={handleRedirectManual}
                  >
                    {"My House Is Not Listed"}
                  </RowButton>
                </li>
              </ul>
            )}
        </form>
      )}
      {step === 2 && (
        <form id={formId} className="property-form" onSubmit={handleFloorInput}>
          <div className="property-form__row">
            <TextField
              id="add-property-address"
              name="entedAddress"
              label={_t("streetOrReference")}
              value={enteredAddress}
              disabled
              placeholder={_t("enterStreetOrReference")}
            />
            <TextField
              id="add-property-number"
              name="street_number"
              label={_t("number")}
              value={formData.street_number}
              disabled
              placeholder={_t("enterNumber")}
            />
          </div>
          <div className="property-form__row">
            <Select
              id="floor_val"
              name="floor"
              label={_t("floorNumber")}
              placeholder={_t("select")}
              value={formData.floor}
              onChange={(e) => {
                handleInputChange(e);
                setFormData((prev) => ({
                  ...prev,
                  door: "",
                }));
              }}
              options={floorVals.map((floor) => ({
                value: floor,
                label: floor,
              }))}
            />
            <Select
              id="door_val"
              name="door"
              label={_t("letter")}
              placeholder={_t("select")}
              value={formData.door}
              onChange={handleInputChange}
              options={
                haveValue(formData?.floor)
                  ? Object.keys(doorVals[formData?.floor]).map((door) => ({
                      value: door,
                      label: door,
                    }))
                  : []
              }
            />
          </div>
          <p className="property-form__manual">
            {_t("wantToAddPropertyManually")}
            <Button
              variant="secondary"
              size="sm"
              onClick={handleRedirectManual}
            >
              {_t("clickHere")}
            </Button>
          </p>
        </form>
      )}
      {step === 4 && (
        <form id={formId} className="property-form" onSubmit={handleSubmit}>
          <div className="property-form__row">
            <TextField
              id="add-property-municipality"
              name="municipality"
              label={_t("municipality")}
              value={formData?.municipality}
              onChange={handleInputChange}
              required
              placeholder={_t("enterMunicipality")}
            />
            <TextField
              id="add-property-province"
              name="province"
              label={_t("province")}
              value={formData?.province}
              onChange={handleInputChange}
              required
              placeholder={_t("enterProvince")}
            />
          </div>
        </form>
      )}
    </Modal>
  );
};

export default AddPropertyManuallyModal;
